/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import { registerPlugin } from '@wordpress/plugins';
import { PluginBlockSettingsMenuItem } from '@wordpress/edit-post';
import { useSelect, useDispatch } from '@wordpress/data';
import { getBlockTypes, serialize } from '@wordpress/blocks';
import { Modal, Card, CardFooter, Button, CardBody, TextControl } from '@wordpress/components';
import { store as noticesStore } from '@wordpress/notices';

const PluginBlockSettingsMenuGroupTest = ( ) => {
	const block = useSelect( ( select ) => {
		return select( 'core/block-editor' ).getSelectedBlock();
	}, [] );
	const [ openModel, setOpenModel ] = useState( false );
	const [ templateTitle, setTemplateTitle ] = useState( '' );
	const [ hasTitleError, setTitleError ] = useState( false );
	// const { saveEntityRecord } = useSelect( ( select ) => {
	// 	return select( 'core' );
	// }, [] );
	const {
		// getBlocksByClientId,
		// getSelectedBlockClientIds,
		// hasMultiSelection,
		saveEntityRecord,
	} = useDispatch( 'core' );
	const { createSuccessNotice, createErrorNotice } = useDispatch( noticesStore );

	const allBlocksNames = getBlockTypes().map( ( blockInfo ) => {
		return blockInfo.name;
	} );

	return (
		<>
			<PluginBlockSettingsMenuItem
				allowedBlocks={ allBlocksNames }
				icon="open-folder"
				label={ __( 'Save template' ) }
				onClick={ ( ) => {
				// wp.data.select('core/block-editor').getSelectedBlock()
				// console.log( block );
				// console.log( ( getSaveElement( block.name, block.attributes, block.innerBlocks ) ) );
				// console.log( getBlockContent( createBlock( block.name, block.attributes, block.innerBlocks ) ) );
				// const blocks = getBlocksByClientId(  block.clientId );
					setOpenModel( true );
				} }
			/>
			{ openModel && (
				<Modal title={ __( 'Save Template' ) } onRequestClose={ () => setOpenModel( false ) }>
					<Card isBorderless={ true } >
						<CardBody>
							<TextControl value={ templateTitle } onChange={ ( title ) => {
								setTemplateTitle( title );
								setTitleError( false );
							} } label={ __( 'Title' ) } className={ hasTitleError ? 'gutenify-field-error' : '' } />
						</CardBody>
						<CardFooter>
							<Button variant="secondary" onClick={ () => {
								setOpenModel( false );
							} }>
								{ __( 'Cancel' ) }
							</Button>
							<Button variant="primary" onClick={ () => {
								if ( '' === templateTitle ) {
									createErrorNotice( __( 'Please enter template title.' ), {
										type: 'snackbar',
									} );
									setTitleError( true );
									return false;
								}
								setTitleError( false );
								const serialized = serialize( block );
								saveEntityRecord( 'postType', 'gutenify_template', { title: templateTitle, content: serialized, status: 'publish' } ).then( ( ) => {
									createSuccessNotice( __( 'Saved template.' ), {
										type: 'snackbar',
									} );
									setOpenModel( false );
								} ).catch( ( ) => {
									createSuccessNotice( __( 'There was error saving template.' ), {
										type: 'snackbar',
									} );
								} );
							} }>
								{ __( 'Save' ) }
							</Button>
						</CardFooter>
					</Card>
				</Modal>
			) }
		</>
	);
};

registerPlugin( 'block-settings-menu-group-test', {
	render: PluginBlockSettingsMenuGroupTest,
} );
